/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Abweichendeschule1Inputs */

const de__field_abweichendeschule1 = /** @type {(inputs: _Field_Abweichendeschule1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abweichende Schule`)
};

/**

* @param {_Field_Abweichendeschule1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_abweichendeschule1 = /** @type {((inputs?: _Field_Abweichendeschule1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Abweichendeschule1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_abweichendeschule1(inputs)
});
export { _field_abweichendeschule1 as "_field_abweichendeSchule" }